import { Tooltip, IconButton, Stack } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { Column } from 'components/shared/TableListing/types';
import { CheckboxField } from 'components/form';
import {
  ScoreCriteriasTableContext,
  ScoreCriteriaEntity,
  ScoreTierEntity,
  ScoreTiersTableContext,
  CustomScorecardCriteriaType,
} from './types';
import { green, grey, orange, red, yellow } from '@mui/material/colors';
import { ColorPickerField, InputField } from 'components/form';
import { Controller } from 'react-hook-form';

export const newScoreCriteria: ScoreCriteriaEntity = {
  criteria: null,
  customCriteria: {},
};

export const initialScoreCriteriaTableData: ScoreCriteriaEntity[] = [
  {
    criteria: null,
    customCriteria: {},
  },
];

export const initialScoreCriteriaColumns: Column<
  ScoreCriteriaEntity,
  ScoreCriteriasTableContext,
  string,
  CustomScorecardCriteriaType
>[] = [
  {
    width: '4.5rem',
    header: 'Actions',
    renderKey: 'actions',
    renderCell: ({ context: { handleRemoveRow }, rowIndex }) => (
      <Tooltip title="Remove Score">
        <IconButton
          onClick={() => {
            handleRemoveRow(rowIndex);
          }}
        >
          <DeleteOutline color="error" />
        </IconButton>
      </Tooltip>
    ),
  },
];

export const newTier: ScoreTierEntity = {
  name: 'New',
  color: 'black',
  scoreRange: { min: '', max: '' },
  isAutoApprove: false,
  isAutoDecline: false,
};

export const initialScoreTiersTableData: ScoreTierEntity[] = [
  { color: green['400'], name: 'Prime' },
  { color: yellow['400'], name: 'Near-Prime' },
  { color: orange['400'], name: 'Mid-Tier' },
  { color: red['400'], name: 'Subprime' },
  { color: grey['400'], name: 'Not qualified' },
].map(tier => ({ ...tier, scoreRange: { min: '', max: '' }, isAutoApprove: false, isAutoDecline: false }));

export const initialScoreTiersColumns: Column<ScoreTierEntity, ScoreTiersTableContext>[] = [
  {
    width: '4.5rem',
    header: 'Actions',
    renderKey: 'actions',
    renderCell: ({ context: { handleRemoveRow }, rowIndex }) => (
      <Tooltip title="Remove Tier">
        <IconButton
          onClick={() => {
            handleRemoveRow(rowIndex);
          }}
        >
          <DeleteOutline color="error" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    renderKey: 'name',
    header: 'Internal Tier Name',
    renderCell: ({ context: { form }, rowIndex }) => (
      <Stack direction="row" gap="1rem" width="100%" alignItems="center">
        <Controller
          control={form.control}
          name={`bodyFields.${rowIndex}.color`}
          render={({ field: { value, onChange } }) => (
            <ColorPickerField
              initialColor={value ?? initialScoreTiersTableData[rowIndex].color}
              onColorChanged={onChange}
            />
          )}
        />

        <InputField control={form.control} inputProps={{ variant: 'outlined' }} name={`bodyFields.${rowIndex}.name`} />
      </Stack>
    ),
  },
  {
    renderKey: 'score',
    header: 'Score',
    renderCell: ({ context: { form }, rowIndex }) => (
      <Stack direction="row" gap="0.5rem" width="100%">
        <InputField
          control={form.control}
          name={`bodyFields.${rowIndex}.scoreRange.min`}
          inputProps={{ variant: 'outlined', placeholder: 'Min', type: 'number' }}
        />

        <InputField
          control={form.control}
          name={`bodyFields.${rowIndex}.scoreRange.max`}
          inputProps={{ variant: 'outlined', placeholder: 'Max', type: 'number' }}
        />
      </Stack>
    ),
  },
  {
    renderKey: 'autoActions',
    header: 'Automatic Actions',
    renderCell: ({ context: { form }, rowIndex }) => (
      <Stack direction="column" gap="0.5rem" width="100%">
        <CheckboxField
          control={form.control}
          name={`bodyFields.${rowIndex}.isAutoApprove`}
          label="Auto Approve"
          extraAction={checked => {
            if (checked) {
              form.setValue(`bodyFields.${rowIndex}.isAutoDecline`, false);
            }
          }}
        />
        <CheckboxField
          control={form.control}
          name={`bodyFields.${rowIndex}.isAutoDecline`}
          label="Auto Decline"
          extraAction={checked => {
            if (checked) {
              form.setValue(`bodyFields.${rowIndex}.isAutoApprove`, false);
            }
          }}
        />
      </Stack>
    ),
  },
];
